import productImg from 'src/assets/images/product.png'
import newImg from "src/assets/images/new.png"
import addtobom from "src/assets/images/addtobom-icon.svg";
import DisplayLifeCycleRisk from "../../component/custom/DisplayLifeCycleRisk";
import ProductCompareSelection from "../ProductCompare/ProductCompareSelection";
import NavigateToProductDetail from "../../component/custom/NavigateToProductDetail";
import DisplayQtyMinQtyMult from "../../component/custom/DisplayQtyMinQtyMult";
import { useSearchParams } from "react-router-dom";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import React, { useState } from "react";
import PriceTable from "../../component/custom/PriceTable";
import AddToBom from "../../component/custom/AddToBom";
import AddToCart from "../../component/custom/AddToCart";
import Helper from "../../helper/Helper";
import ReactPaginate from "react-paginate";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import FactoryLeadTimeDisplay from 'src/component/custom/FactoryLeadTimeDisplay';
import ReusableDiv from 'src/helper/ReusableDiv';
import { useProductStore } from 'src/hooks/product';
import QuantityPicker from 'src/component/custom/QuantityPicker';
import { useProductFilterStore } from 'src/hooks/productFilter';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import liveAuth from 'src/helper/liveAuth';

export function ProductListingMobile(props) {
    const [{ productListWithFacet, model_ProductCompare_data }, { }, { }, { }] = useProductStore();
    const [{ filterBoxSelection }, { }, { }, { }] = useProductFilterStore();
    const { isBomPLP } = props
    const [{  }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const { systemModules: { PLP } } = Constants

    const [searchParams] = useSearchParams();
    const [pageCount] = useState(0);
    const [page, setPage] = useState(searchParams.get("page") ? searchParams.get("page") : 1);
    const [limit, setLimit] = useState(searchParams.get("limit") ? searchParams.get("limit") : 10);
    const [__check] = useAxiosIndicatorCheck();

    const detectDynamicFieldIsAttribute = (field) => {
        return System.getFieldType(field) === Constants.CognitiveSearchFieldConfig.attributes;
    };

    const avUserInfo = liveAuth.getAvUserInfo()

    const setPageLimit = async (event) => {
        setLimit(event.target.value)
    };
    const handlePageClick = async (data) => {
        let here_page = data.selected + 1;
        setPage(here_page)
        Helper.scrollTop();
    };
    const [firstServerCall, setFirstServerCall] = useState(true);
    return (
        <>
            {firstServerCall &&
                <>
                    {__check('PRODUCT_LISTING_API_CALL').render}
                </>
            }
            <div className="mobile-view product-list-mobile-view">
                <div className="container pt-1">
                    <div className="product-list">
                        {productListWithFacet?.value?.length > 0 &&
                            productListWithFacet?.value.map((v, i) => (
                                <React.Fragment key={i}>
                                    <div className="product-row">
                                        <div className="product-row-top">
                                            <div className="col-4 product-info nopadding">
                                                <div className="product-img sect-1 text-center">
                                                    <a rel="nofollow" href={void (0)}>
                                                        <img className="img" src={productImg} alt="LM339PT" />
                                                    </a>
                                                </div>
                                                <div className="sect-2">
                                                    <div className="sect-row">
                                                        <div className="add-to-bom">
                                                            <a
                                                                onClick={() => {
                                                                    System.popup('AddToBOMPopup', { single_product: v, addFrom: PLP })
                                                                }}
                                                                className="img-text">
                                                                <img src={addtobom} alt='BOM' />

                                                                <span className="blue text">Add To BOM</span>
                                                            </a>
                                                        </div>
                                                        {(v.DatasheetUrl && v.DatasheetUrl.trim() !== '') ?
                                                            <div className="datasheet">
                                                                <a className="datasheet-align img-text"
                                                                    rel="nofollow"
                                                                    href={v.DatasheetUrl}
                                                                    target="_new">
                                                                    <div className="datasheet_img datasheet_img_download img" />
                                                                    <span className="blue text">Datasheet</span>
                                                                </a>
                                                            </div>
                                                            : ReusableDiv.dataSheetTooltip()
                                                        }

                                                        <DisplayLifeCycleRisk single_product={v} />
                                                    </div>
                                                    <div className="shipping_address_checkbox">
                                                        <ProductCompareSelection single_product={v}
                                                            model_ProductCompare_data={model_ProductCompare_data} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-8">
                                                <div className="prod-info-right">
                                                    <div className="product-name text-blue cursor-pointer">
                                                        <NavigateToProductDetail
                                                            data={{ SEOManufacturerName: v?.SEOManufacturerName, SEOERPMFRPartNumber: v?.SEOERPMFRPartNumber, ItemNumber: v?.ItemNumber, ERPPartNumber: v?.ERPPartNumber }}>
                                                            <strong>{v?.ManufacturerPartNumber ? v.ManufacturerPartNumber : ''}</strong>
                                                        </NavigateToProductDetail>
                                                    </div>
                                                    <div className="grey">
                                                        {v.ManufacturerName ? v.ManufacturerName : ''}
                                                    </div>
                                                    <div className="summary more_summary">
                                                        {v?.LongDescription ?
                                                            <div
                                                                className="summary more_summary"> {v.LongDescription}
                                                                <a
                                                                    className="readmore" href="">… More</a>
                                                            </div> : ''}
                                                    </div>
                                                    <div
                                                        className="text-start small-text light light-text collapse_minmax">
                                                        <DisplayQtyMinQtyMult
                                                            single_product={v} />
                                                    </div>
                                                    <div className="quantity clearfix ">
                                                        <div className="quantity-picker">
                                                            <div
                                                                className="bs5 input-group flex-nowrap border-0">
                                                                <QuantityPicker single_product={v}
                                                                    single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                                                                    single_product_pricing_list={get_pricing_by_id({ ItemNumber: v.ItemNumber })}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <AddToBom
                                                        isBomPLP={isBomPLP}
                                                        single_product={v} />
                                                    <AddToCart
                                                        special_class_for_add_to_quote={'bs5 btn btn-secondary'}
                                                        isBomPLP={isBomPLP}
                                                        single_product_pricing_list={get_pricing_by_id({
                                                            ItemNumber: v.ItemNumber
                                                        })}
                                                        single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                                                        single_product={v}
                                                        isFrom={PLP} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="bs5 row product-row-bottom">
                                            <div className="col-6">
                                                {avUserInfo &&
                                                    <PriceTable
                                                        single_product_inventory={get_inventory_by_id(v.ItemNumber)}
                                                        single_product={v}
                                                        single_product_pricing_list={get_pricing_by_id({
                                                            ItemNumber: v.ItemNumber
                                                        })} />
                                                }
                                            </div>
                                            <div className="col-6">
                                                <ul className="list-text availibility-list-text">
                                                    <li className="text-darkgreen">
                                                        <i className="fa fa-check-circle me-1" />
                                                        <span>
                                                            <b>{0}</b>
                                                            <span> - In Stock</span>
                                                        </span>
                                                    </li>
                                                </ul>
                                                <div className="factory-stock">
                                                    <div className="factory-stock-label">
                                                        Factory Stock:
                                                        <i className="fa fa-info-circle" />
                                                    </div>
                                                    <div className="factory-stock-amount">
                                                        2,318
                                                    </div>
                                                </div>
                                                <ul className="list-text availibility-list-text">
                                                    <li>
                                                        <FactoryLeadTimeDisplay
                                                            single_product={v}
                                                            single_product_inventory={get_inventory_by_id(v.ItemNumber)} />
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className="col-12 text-center">
                                                <p className="d-flex align-items-center justify-content-center mt-2 m-auto">
                                                    <img src={newImg} />
                                                    <span className="text-ports ms-2">
                                                        <b>Additional Newark Stock</b>
                                                    </span>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="prod-attribute">
                                            <a className="bs5 btn btn-primary" data-toggle="collapse"
                                                href={`#additional-info` + v.ERPPartNumber}
                                                role="button" aria-expanded="false" aria-controls="additional-info">
                                                Check Additional Stock and Lead Time
                                            </a>
                                            <div className="collapse" id={`additional-info` + v.ERPPartNumber}>
                                                <div className="card p-15">
                                                    <p>Additinal Stock Lead Time: 6 weeks</p>
                                                    <b>STOCK ON ORDER</b>
                                                    <p>Additional on-order with QTY: 3750</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="prod-attribute">
                                            <a className="bs5 btn btn-primary" data-toggle="collapse"
                                                href={`#prod-attri` + v.ERPPartNumber}
                                                role="button" aria-expanded="false" aria-controls="prod-attri">
                                                View Attributes
                                            </a>
                                            <div className="collapse" id={`prod-attri` + v.ERPPartNumber}>
                                                <div className="table-responsive">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                {filterBoxSelection && Object.entries(filterBoxSelection).length > 0 &&
                                                                    Object.entries(filterBoxSelection).map((v) => (
                                                                        <React.Fragment key={Helper.UUID()}>
                                                                            {detectDynamicFieldIsAttribute(v[1].slug) &&
                                                                                <th>{v[1].main_label}</th>
                                                                            }
                                                                        </React.Fragment>
                                                                    ))
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                {filterBoxSelection && Object.entries(filterBoxSelection).length > 0 &&
                                                                    Object.entries(filterBoxSelection).map((v_listing) => (
                                                                        <React.Fragment key={Helper.UUID()}>
                                                                            {detectDynamicFieldIsAttribute(v_listing[1].slug) &&
                                                                                <td>
                                                                                    {v?.dynamic_columns &&
                                                                                        v.dynamic_columns[v_listing[1].slug] &&
                                                                                        <>
                                                                                            {v.dynamic_columns[v_listing[1].slug]}
                                                                                        </>
                                                                                    }
                                                                                </td>
                                                                            }
                                                                        </React.Fragment>
                                                                    ))
                                                                }
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </React.Fragment>
                            ))}
                    </div>
                    <div className="pagination-row">
                        <div className="pagination-wrapper">
                            <ReactPaginate
                                initialPage={page - 1}
                                previousLabel={"Previous"}
                                nextLabel={"First"}
                                breakLabel={"..."}
                                pageCount={pageCount}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={3}
                                onPageChange={handlePageClick}
                                containerClassName={"pagination pagination-sm m-0"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                        <div className="page-size">
                            <label className="mb-0">Results Per Page:</label>
                            <span className="selectbox">
                                <select onChange={setPageLimit} value={parseInt(limit)}>
                                    <option value={10}>10</option>
                                    <option value={20}>20</option>
                                    <option value={50}>50</option>
                                </select>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
